export default theme => ({
  title: {
    fontWeight: 500,
  },
});
